import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import {
  Paper,
  Popover,
  Tooltip,
  withStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";
import { FormLabel, TextField, Button } from "@material-ui/core";

import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function ViewAllocatedCenter() {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [search, setSearch] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [allocatedCenters, setAllocatedCenters] = useState([]);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  
  const [page, setPage] = useState(0);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };

  const [rowCount, setRowCount] = useState("");

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editCenter") {
      navigate(`/admin/editallocatedcenter/${rowId}`);
    }
  };

  const handleSearch = (query) => {
    setSearch(query);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async (pageNumber, size) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/v1/b2b/registration_allocated/centers?page=${
          pageNumber + 1
        }&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log("hello", response);
      setAllocatedCenters(response.data.allocated_centers);
      setRowCount(response.data.count);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    if (onPage !== undefined && pageSize !== undefined && search !== undefined) {
      fetchData(onPage, pageSize);
    }
  }, [onPage, pageSize, search]);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      fetchData(onPage, pageSize, searchQuery);
      handleClose();
      toast.success("Allocation center deleted successfully");
      const updateddatatata = allocatedCenters.filter(
        (data) => data.id !== rowId
      );
      setAllocatedCenters(updateddatatata);
    } catch (error) {
      toast.error("Allocation center is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      allocated_centers: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/status`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        console.log("Center status changed successfully", response);
        fetchData(onPage, pageSize, searchQuery);
        toast.success("Center status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Center status:", error);
        toast.error("Center status is not changed");
      });
  };

  const rows = allocatedCenters.map((d) => ({
    id: d.id ? d.id : "N/A",
    center_name: d?.center_name ? d?.center_name : "N/A",
    center_code: d?.center_code ? d?.center_code : "N/A",
    Center_id: d?.branch?.center_name ? d?.branch?.center_name : "N/A",
    center_address: d?.center_address ? d?.center_address : "N/A",
    city_name: d?.city_name ? d?.city_name : "N/A",
    state_name: d?.state_name ? d?.state_name : "N/A",
    tca_name: d?.tca_name ? d?.tca_name : "N/A",
    tca_mobile_number: d?.tca_mobile_number ? d?.tca_mobile_number : "N/A",
    capacity_per_shift: d?.capacity_per_shift ? d?.capacity_per_shift : "N/A",
    max_scheduling: d?.max_scheduling ? d?.max_scheduling : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
  }));
  const startIndex = onPage * pageSize;

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d.center_name.toLowerCase().includes(search.toLowerCase());
      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: startIndex + index + 1,
    }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "center_name",
      headerName: "Center Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Center Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "Center_id",
      headerName: "Branch Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "center_address",
    //   headerName: "Center Address",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "city_name",
    //   headerName: "City",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "state_name",
    //   headerName: "State",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "tca_name",
      headerName: "TCA Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "tca_mobile_number",
      headerName: "TCA Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "capacity_per_shift",
    //   headerName: "Capacity Per Shift",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "max_scheduling",
    //   headerName: "Maximum Scheduling",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 200,
    //   // flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.active_status === "active";

        return (
          <div
            className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                  onClick={(event) => {
                    handleStatus(
                      cellValues.row.id,
                      cellValues.row.active_status
                    );
                    handleClose();
                  }}
                >
                  <LightTooltip title="Inactive">
                    <VisibilityOffOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton
                  onClick={() => {
                    handleButtonClick("editCenter", cellValues.row.id);
                    handleClose();
                  }}
                >
                  <LightTooltip title="Edit">
                    <EditOutlinedIcon />
                  </LightTooltip>
                </IconButton>
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => {
                        deleteDataOfRow(cellValues.row.id);
                        handleClose();
                      }}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      inputlable: " ",
      inputplaceholder: "Center Name",
      import: "yes",
      export :"yes",
      exportFileName:"Center.csv",
      exportApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/center/export/all`,
      importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/center/import`,
      fetchData: () => fetchData(onPage, pageSize),
    },
  ];

  const style = [
    {
      height: "maxh67",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
      // checkboxselection: "true",
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <div className={`${classes.dflex} ${classes.alignitemscenter} ${classes.w100}`}>
          <div style={{ flex: 1 }}>
            <TableViewSearch Heading={Heading} onSearch={handleSearch} />
          </div>
          <Button
            className={`${classes.custombtnblue} ${classes.mr1}`}
            onClick={() => navigate('/admin/assignbranch')}
          >
            Assign Branch
          </Button>
        </div>

        {/* Manual search (commented out — now handled by TableViewSearch above)
        <div className={`${classes.dflex} ${classes.m0_5}`}>
          <div
            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
            >
              Search
            </FormLabel>
            <TextField
              type="text"
              variant="outlined"
              required
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Center Name"
            />
          </div>
          <div className={`${classes.dflex} ${classes.flexdirectioncolumn}`}>
            <Button
              className={`${classes.custombtnblue} ${classes.mt1_5} ${classes.ml0_5}`}
              onClick={() => fetchData(onPage, pageSize)}
            >
              search
            </Button>
          </div>
        </div>
        */}

        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
    </>
  );
}
export default ViewAllocatedCenter;
